<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab small color="primary" v-bind="attrs" v-on="on">
          <v-icon dark>
            mdi-share-variant
          </v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="n in networks" :key="n.name">
          <v-list-item-title>
            <ShareNetwork
              :network="n.name"
              :url="n.url"
              :title="title"
              description="Se vad jag hittade på Livet i havet"
              hashtags="Livet,havet"
            >
              <v-icon :color="n.color" class="">{{ n.icon }}</v-icon>
              <span class="ml-2" :style="'color:' + n.color">{{
                n.title
              }}</span>
            </ShareNetwork>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-icon color="#21a261" class="">mdi-link-variant</v-icon>
            <span class="ml-2"
              ><a href="kopiera länk" @click.prevent="copyLink">Länk</a>
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-snackbar v-model="snackbar" :timeout="2000">
      Adressen till sidan kopierad!

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Stäng
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'SocialShare',
  data() {
    return {
      snackbar: false,
      networks: [
        {
          name: 'facebook',
          title: 'Facebook',
          url: document.URL,
          icon: 'mdi-facebook',
          color: '#4267B2'
        },
        {
          name: 'twitter',
          title: 'Twitter',
          url: document.URL,
          icon: 'mdi-twitter',
          color: '#1DA1F2'
        }
      ]
    }
  },
  computed: {
    title() {
      return document.title
    }
  },
  methods: {
    async copyLink() {
      const area = this.$store.getters.areaName
      const url = window.location.href.includes('area=')
        ? `${window.location.href}`
        : `${window.location.href}?area=${area}`
      console.log(url)
      await navigator.clipboard.writeText(url)
      this.snackbar = true
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: unset;
}
</style>
